*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-flex;
}

.tooltip-trigger {
  display: inline-flex;
}

.tooltip-anchor {
  position: relative;
  display: inline-flex;
}

.tooltip-panel {
  --wui-internal-glass-shadow: var(--wui-shadow-panel, 0 3px 9px rgb(0 0 0 / 0.27));

  pointer-events: none;

  position: absolute;
  z-index: var(--wui-layer-inline-overlay, 1);
  top: -9999px;
  left: -9999px;

  box-sizing: border-box;
  width: max-content;
  max-width: var(--wui-tooltip-max-width, 240px);
  padding: 6px 10px;
  border-radius: 20px;

  font-size: var(--wui-tooltip-font-size, 13px);
  color: var(--wui-color-text, #1b1b1b);

  background-color: var(--wui-color-surface-overlay, rgb(246 246 246 / 0.82));
}

.tooltip-panel.portal {
  position: fixed;
  z-index: var(--wui-layer-menu, 100);
}

.tooltip-panel.hidden {
  display: none;
}

.tooltip-text {
  display: block;
  overflow-wrap: break-word;
  white-space: normal;
}

:host([portal]) .tooltip-panel {
  display: none;
}
